export const pricesProducts = {
  trial: {
    amplicon: {
      mick: { nutrition: 14.99, health: 29.99 },
      mickPlus: { nutrition: 99.0, health: 129.0 },
    },
    wgs: {
      mick: { health: 49.99, branding: 9.99 },
      mickPlus: { health: 250.0, branding: 9.99 },
    },
  },
  professional: {
    amplicon: {
      mick: { nutrition: 14.99, health: 29.99 },
      mickPlus: { nutrition: 99.0, health: 129.0 },
    },
    wgs: {
      mick: { health: 49.99, branding: 9.99 },
      mickPlus: { health: 250.0, branding: 9.99 },
    },
  },
  studio: {
    amplicon: {
      mick: { nutrition: 12.99, health: 26.99, branding: 9.99 },
      mickPlus: { nutrition: 99.0, health: 129.0, branding: 9.99 },
    },
    wgs: {
      mick: { health: 44.99, branding: 9.99 },
      mickPlus: { health: 250.0, branding: 9.99 },
    },
  },
  lab: {
    amplicon: {
      mick: { nutrition: 10.99, health: 24.99, branding: 9.99 },
      mickPlus: { nutrition: 99.0, health: 129.0, branding: 9.99 },
    },
    wgs: {
      mick: { health: 32.99, branding: 9.99 },
      mickPlus: { health: 250.0, branding: 9.99 },
    },
  },
  corporate: {
    amplicon: {
      mick: { nutrition: 10.99, health: 24.99, branding: 9.99 },
      mickPlus: { nutrition: 99.0, health: 129.0, branding: 9.99 },
    },
    wgs: {
      mick: { health: 32.99, branding: 9.99 },
      mickPlus: { health: 250.0, branding: 9.99 },
    },
  },
  unlimited: {
    amplicon: {
      mick: { nutrition: 0, health: 0, branding: 0 },
      mickPlus: { nutrition: 0, health: 0, branding: 0 },
    },
    wgs: {
      mick: { health: 0, branding: 0 },
      mickPlus: { health: 0, branding: 0 },
    },
  },
};

// INFO FOR BILLING CARDS
// IDs from Stripe
export const pricesData = {
  en: [
    {
      key: 0,
      ids: {
        monthly: ["price_1ItUKlBgIqmR4Bfa6ooMXmJn", "price_1IVuPmBgIqmR4BfalJtfe2xo"],
        annual: ["price_1IvLcaBgIqmR4BfaFruAWZHv"],
      },
      idsTest: {
        monthly: [
          "price_1ItTlPBgIqmR4BfaVQ98E2yi",
          "price_1ITUD9BgIqmR4BfabIE7bld7",
          "price_1HzMMdBgIqmR4BfaSP7NwBFf",
        ],
        annual: ["price_1IvN5yBgIqmR4BfayXeOgKdt"],
      },
      pricesValue: {
        monthly: 24.99,
        annual: 239.90,
      },
      icon: "iconsminds-apple-bite",
      iconSrc: "/assets/img/avatar-mick.png",
      title: "PROFESSIONAL",
      price: "24<small>.99</small>",
      detail: "€/month",
      link: "#",
      description:
        "Perfect for doctors. Allows for one single user and a limited amount of patients per month.",
      features: [
        "Single user",
        "50 patients",
        "starting from 14.99 €",
        "Not available",
      ],
    },
    {
      key: 1,
      ids: {
        monthly: ["price_1ItUigBgIqmR4BfaBZmpt0Rw", "price_1IVuThBgIqmR4BfaduqCR0oc"],
        annual: ["price_1IvLbCBgIqmR4Bfa0jRx42Z4"],
      },
      idsTest: {
        monthly: ["price_1It9rIBgIqmR4BfaXAGX8pB5",
          "price_1ITUAqBgIqmR4BfaPm0727uP",
          "price_1HUYglBgIqmR4BfadMrWSJvI",
        ],
        annual: ["price_1IvNpdBgIqmR4Bfa9qDVNul5"],
      },
      pricesValue: {
        monthly: 44.99,
        annual: 479.90,
      },

      icon: "iconsminds-apple-bite",
      iconSrc: "/assets/img/avatar-mick.png",
      title: "STUDIO",
      price: "49<small>.99</small>",
      detail: "€/month",
      link: "#",
      description: "Specifically designed for small teams with up to 3 users.",
      features: [
        "Up to 3 users <br /><small>(9.99 €/month per extra user)</small>",
        "Unlimited",
        "starting from 12.99 €",
        "1 included <br><small>(9.99 € per extra change)</small>",
      ],
    },
    {
      key: 2,
      ids: {
        monthly: ["price_1ItUtVBgIqmR4BfaH33E701v", "price_1IVuV6BgIqmR4BfaehVneOdH"],
        annual: ["price_1IvLaABgIqmR4Bfa9XBRZxQJ"],
      },
      idsTest: {
        monthly: [
          "price_1ItTZ9BgIqmR4BfaYIqOpQ0K",
          "price_1IU8ulBgIqmR4BfaErK4YVYg",
          "price_1HUZiwBgIqmR4BfaPoJA2Fh8",
        ],
        annual: ["price_1IvNpKBgIqmR4BfaWzP8AuTH"],
      },
      pricesValue: {
        monthly: 79.99,
        annual: 767.90,
      },
      icon: "iconsminds-optimization",
      iconSrc: "/assets/img/avatar-mick.png",
      title: "LAB",
      price: "79<small>.99</small>",
      detail: "€/month",
      link: "#",
      description: "Perfect for medium to large teams with multiple users.",
      features: [
        "Up to 8 users <br><small>(9.99 €/month per extra user)</small>",
        "Unlimited",
        "starting from 10.99 €",
        "1 included <br><small>(9.99 € per extra change)</small>",
      ],
    },
    {
      key: 3,
      ids: {
        monthly: ["price_1ItUSLBgIqmR4BfaAYrI2red", "price_1IVuW5BgIqmR4Bfac7JJTz5I"],
        annual: ["price_1IvLbsBgIqmR4BfaLQUlafoW"],
      },
      idsTest: {
        monthly: [
          "price_1ItTwQBgIqmR4Bfa1v3efrtF",
          "price_1I8khaBgIqmR4BfaiPNKMJlN",
          "price_1IU8vVBgIqmR4BfanXRRkped",
        ],
        annual: ["price_1IvNoqBgIqmR4BfaqNz9LiNu"],
      },
      pricesValue: {
        monthly: 149.99,
        annual: 1439.90,
      },
      icon: "iconsminds-optimization",
      iconSrc: "/assets/img/avatar-mick.png",
      title: "CORPORATE",
      price: "149<small>.00</small>",
      detail: "€/month",
      link: "#",
      description:
        "Perfect for diagnostics centers (medical lab) with multiple branches, omics centers and distributors.",
      features: [
        "Up to 10 users <br><small>(9.99 €/month per extra user)</small>",
        "500 patients",
        "starting from 10.99 €",
        "1 included <br><small>(9.99 € per extra change)</small>",
        "Up to 6 affiliations <br><small>(9.99 €/month per extra affiliations)</small>",
      ],
    },
  ],
  es: [],
};

// INFO FOR BILLING CARDS
export const pricesAnalysisPluginsData = {
  en: [
    {
      title: "PROFESSIONAL",
      pricesAmplicon: {
        mick: ["€ 14<sup>99</sup>", "€ 29<sup>99</sup>"],
        mickPlus: ["€ 99<sup>00</sup>", "€ 129<sup>00</sup>"],
      },
      pricesShotgun: {
        mick: ["€ 49<sup>99</sup>"],
        mickPlus: ["€ 250<sup>00</sup>"],
      },
      branding: "N/A",
    },
    {
      title: "STUDIO",
      pricesAmplicon: {
        mick: ["€ 12<sup>99</sup>", "€ 26<sup>99</sup>"],
        mickPlus: ["€ 99<sup>00</sup>", "€ 129<sup>00</sup>"],
      },
      pricesShotgun: {
        mick: ["€ 44<sup>99</sup>"],
        mickPlus: ["€ 250<sup>00</sup>"],
      },
      branding: "9.99",
    },
    {
      title: "LAB",
      pricesAmplicon: {
        mick: ["€ 10<sup>99</sup>", "€ 24<sup>99</sup>"],
        mickPlus: ["€ 99<sup>00</sup>", "€ 129<sup>00</sup>"],
      },
      pricesShotgun: {
        mick: ["€ 32<sup>99</sup>"],
        mickPlus: ["€ 250<sup>00</sup>"],
      },
      branding: "9.99",
    },
  ],
};

export const popularDomains = [
  /* Default domains included */
  "aol.com",
  "att.net",
  "comcast.net",
  "facebook.com",
  "gmail.com",
  "gmx.com",
  "googlemail.com",
  "google.com",
  "hotmail.com",
  "hotmail.co.uk",
  "mac.com",
  "me.com",
  "mail.com",
  "msn.com",
  "live.com",
  "sbcglobal.net",
  "verizon.net",
  "yahoo.com",
  "yahoo.co.uk",

  /* Other global domains */
  "email.com",
  "fastmail.fm",
  "games.com" /* AOL */,
  "gmx.net",
  "hush.com",
  "hushmail.com",
  "icloud.com",
  "iname.com",
  "inbox.com",
  "lavabit.com",
  "love.com" /* AOL */,
  "outlook.com",
  "pobox.com",
  "protonmail.ch",
  "protonmail.com",
  "tutanota.de",
  "tutanota.com",
  "tutamail.com",
  "tuta.io",
  "keemail.me",
  "rocketmail.com" /* Yahoo */,
  "safe-mail.net",
  "wow.com" /* AOL */,
  "ygm.com" /* AOL */,
  "ymail.com" /* Yahoo */,
  "zoho.com",
  "yandex.com",

  /* United States ISP domains */
  "bellsouth.net",
  "charter.net",
  "cox.net",
  "earthlink.net",
  "juno.com",

  /* British ISP domains */
  "btinternet.com",
  "virginmedia.com",
  "blueyonder.co.uk",
  "freeserve.co.uk",
  "live.co.uk",
  "ntlworld.com",
  "o2.co.uk",
  "orange.net",
  "sky.com",
  "talktalk.co.uk",
  "tiscali.co.uk",
  "virgin.net",
  "wanadoo.co.uk",
  "bt.com",

  /* Domains used in Asia */
  "sina.com",
  "sina.cn",
  "qq.com",
  "naver.com",
  "hanmail.net",
  "daum.net",
  "nate.com",
  "yahoo.co.jp",
  "yahoo.co.kr",
  "yahoo.co.id",
  "yahoo.co.in",
  "yahoo.com.sg",
  "yahoo.com.ph",
  "163.com",
  "yeah.net",
  "126.com",
  "21cn.com",
  "aliyun.com",
  "foxmail.com",

  /* French ISP domains */
  "hotmail.fr",
  "live.fr",
  "laposte.net",
  "yahoo.fr",
  "wanadoo.fr",
  "orange.fr",
  "gmx.fr",
  "sfr.fr",
  "neuf.fr",
  "free.fr",

  /* German ISP domains */
  "gmx.de",
  "hotmail.de",
  "live.de",
  "online.de",
  "t-online.de" /* T-Mobile */,
  "web.de",
  "yahoo.de",

  /* Italian ISP domains */
  "libero.it",
  "virgilio.it",
  "hotmail.it",
  "aol.it",
  "tiscali.it",
  "alice.it",
  "live.it",
  "yahoo.it",
  "email.it",
  "tin.it",
  "poste.it",
  "teletu.it",

  /* Russian ISP domains */
  "mail.ru",
  "rambler.ru",
  "yandex.ru",
  "ya.ru",
  "list.ru",

  /* Belgian ISP domains */
  "hotmail.be",
  "live.be",
  "skynet.be",
  "voo.be",
  "tvcablenet.be",
  "telenet.be",

  /* Argentinian ISP domains */
  "hotmail.com.ar",
  "live.com.ar",
  "yahoo.com.ar",
  "fibertel.com.ar",
  "speedy.com.ar",
  "arnet.com.ar",

  /* Domains used in Mexico */
  "yahoo.com.mx",
  "live.com.mx",
  "hotmail.es",
  "hotmail.com.mx",
  "prodigy.net.mx",

  /* Domains used in Canada */
  "yahoo.ca",
  "hotmail.ca",
  "bell.net",
  "shaw.ca",
  "sympatico.ca",
  "rogers.com",

  /* Domains used in Brazil */
  "yahoo.com.br",
  "hotmail.com.br",
  "outlook.com.br",
  "uol.com.br",
  "bol.com.br",
  "terra.com.br",
  "ig.com.br",
  "itelefonica.com.br",
  "r7.com",
  "zipmail.com.br",
  "globo.com",
  "globomail.com",
  "oi.com.br",
];
